import React__default from 'react';
import { Box, Button } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import KModalContentSection from '../../KModal/KModalContentSection/index.js';
import SanitizeHtml from '../../SanitizeHtml/index.js';
import StyledImportSuccess, { classes } from './index.styled.js';

var ImportSuccess = function (_a) {
    var _b = _a.testId, testId = _b === void 0 ? "ImportSuccess" : _b, id = _a.id, className = _a.className, elements = _a.elements, email = _a.email, onClose = _a.onClose, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    var t = useTranslation("refront-components").t;
    var pluralizeTranslationKey = function (key) {
        return elements.length > 1 ? "".concat(key, "_plural") : key;
    };
    return (React__default.createElement(StyledImportSuccess, { id: id, "data-testid": testId, className: clsx("ImportSuccess", className), sx: {
            height: "100%",
            display: "flex",
            justifyContent: "left",
            paddingLeft: function (theme) { return theme.spacing(2); },
            overflowY: "scroll",
            overflow: "auto",
            "::-webkit-scrollbar": {
                display: "none" /* Chrome */
            },
            msOverflowStyle: "none" /* IE and Edge */,
            scrollbarWidth: "none" /* Firefox */
        } },
        React__default.createElement(KModalContentSection, { className: classes.contentSection, sx: {
                width: "25rem",
                alignSelf: "center"
            }, title: React__default.createElement(Box, { sx: {
                    fontSize: "2.5rem",
                    lineHeight: "1",
                    marginBottom: function (theme) { return theme.spacing(2); },
                    color: function (theme) { return theme.palette.common.white; },
                    overflowWrap: "break-word"
                } },
                React__default.createElement(SanitizeHtml, { html: t("components.importSuccess.title") })), description: React__default.createElement(Box, { sx: {
                    color: function (theme) { return theme.palette.common.white; },
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem"
                } },
                React__default.createElement(SanitizeHtml, { html: t(pluralizeTranslationKey("components.importSuccess.content.description")) }),
                React__default.createElement(SanitizeHtml, { html: t(pluralizeTranslationKey("components.importSuccess.content.userInformation"), {
                        email: email
                    }) }),
                React__default.createElement(SanitizeHtml, { html: t("components.importSuccess.content.thankYou") }),
                React__default.createElement(Button, { color: "primary", variant: "contained", "data-testid": "CloseImportModulAfterSuccessButton", sx: {
                        margin: function (theme) { return theme.spacing(1, 0); },
                        padding: function (theme) { return theme.spacing(1, 4); },
                        width: "100%"
                    }, onClick: onClose },
                    React__default.createElement(KIcon, { sx: { marginRight: function (theme) { return theme.spacing(1); }, fontSize: "18px !important" }, className: "fa-regular fa-arrow-right" }),
                    React__default.createElement(SanitizeHtml, { html: t("components.importSuccess.content.actions.close.label") }))) })));
};

export { ImportSuccess as default };
//# sourceMappingURL=index.js.map
